export const lineHeight = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2
} as const;

export type LineHeightKey = keyof typeof lineHeight;

export const lineHeightSemantic = {
  xxs: 1.4,
  xs: 1.4,
  sm: 1.45,
  md: 1.5,
  lg: 1.55,
  xl: 1.4,
  xxl: 1.3,
  xxxl: 1.2
} as const;
